export enum SegmentViewEvents {
    VIEW_LOGIN_DEALER = 'view_login_dealer',
    VIEW_OTP_LOGIN_DEALER = 'view_otp_login_dealer',
    VIEW_HOMEPAGE_DEALER = 'view_homepage_dealer',
    VIEW_DEVICE_MODEL = 'view_device_model',
    VIEW_PLAN = 'view_plan',
    VIEW_SERIAL_NUMBER_SCAN = 'view_serial_number_scan',
    VIEW_UPLOAD_DOCUMENTS = 'view_upload_documents',
    VIEW_CUSTOMER_LINK_SHARE = 'view_customer_link_share_page',
    VIEW_DEALER_WAITING_FOR_PAYMENT = 'view_dealer_waiting_for_payment',
    VIEW_DEALER_PAYMENT = 'view_dealer_payment',
    VIEW_HAMBURGER_SCREEN = 'view_hamburger_screen',
    VIEW_ADD_REMOVE_SUB_DEALER = 'view_add_remove_sub_deader',
    VIEW_CONFIRM_SUB_DEALER = 'view_confirm_sub_dealer',
    VIEW_MY_TRANSACTIONS = 'view_my_transactions',
    VIEW_PAYMENT_SUCCESS = 'view_payment_success',
    VIEW_PAYMENT_FAILURE = 'view_payment_failure',
    // specific to ather
    VIEW_VEHICLE_DETAILS = 'view_vehicle_details',
    VIEW_CUSTOMER_DETAILS = 'view_customer_details',
    REVIEW_DETAILS = 'view_review_details',
}

export enum SegmentTrackEvents {
    TAP_LOGIN = 'tap_login',
    TAP_CTA_CREATE_NEW_PLAN = 'tap_cta_create_new_plan',
    TAP_CTA_PENDING = 'tap_cta_pending',
    TAP_CTA_COMPLETED = 'tap_cta_completed',
    TAP_CTA_MENU = 'tap_cta_menu',
    TAP_CTA_LINK_SENT = 'tap_cta_link_sent',
    TAP_CTA_DEALER_PAYMENT = 'tap_cta_dealer_payment',
    TAP_CTA_RESEND_LINK = 'tap_cta_resend_link',
    TAP_CTA_PAY_ACKO = 'tap_cta_pay_acko',
    TAP_CTA_SELECT_MODEL = 'tap_cta_select_model',
    TAP_BTN_SELECT_PLAN = 'tap_btn_select_plan',
    TAP_LBL_TYPE_SERIAL_NUMBER = 'tap_lbl_type_serial_number',
    TAP_LBL_CONFIRM_SERIAL_NUMBER = 'tap_lbl_confirm_serial_number',
    TAP_CONTINUE_SERIAL_NUMBER_SCAN_PAGE = 'tap_continue_serial_number_scan_page',
    TAP_SUBMIT_SERIAL_NUMBER_MODEL_PAGE = 'tap_submit_serial_number_model_page',
    TAP_CTA_UPLOAD_INVOICE = 'tap_cta_upload_invoice',
    TAP_CTA_UPLOAD_BOX_IMAGE = 'tap_cta_upload_box_image',
    TAP_CONTINUE_UPLOAD_DOCUMENTS_PAGE = 'tap_continue_upload_documents_page',
    TAP_BTN_SEND_TO_CUSTOMER = 'tap_btn_send_to_customer',
    TAP_BTN_GO_HOME = 'tap_btn_go_home',
    TAP_MY_TRANSACTION = 'tap_my_transaction',
    TAP_ADD_REMOVE_SUB_DEALERS = 'tap_add_remove_sub_dealers',
    TAP_CONFIRM_SUB_DEALER = 'tap_confirm_sub_dealer',
    TAP_CTA_EDIT_MODEL = 'tap_cta_edit_model',
    // ather
    TAP_CONTINUE_VEHICLE_DETAILS = 'tap_continue_vehicle_details',
    TAP_CONTINUE_CUSTOMER_DETAILS = 'tap_continue_customer_details',
    TAP_ISSUE_POLICY = 'tap_issue_policy_review_details',
}

export enum SegmentPages {
    LOGIN = 'login',
    LOGIN_OTP = 'login_otp',
    DASHBOARD = 'dashboard',
    NEW_PLAN_DEVICE_MODELS = 'new-plan-device-models',
    NEW_PLAN_PLANS = 'new-plan-plans',
    NEW_PLAN_SERIAL_NUMBER = 'new-plan-serial-number',
    NEW_PLAN_DOCUMENT_UPLOAD = 'new-plan-document-upload',
    NEW_PLAN_SEND_LINK_TO_CUSTOMER = 'new-plan-send-link-to-customer',
    NEW_PLAN_CONGRATULATIONS = 'new-plan-congratulations',
    MANAGE_DEALERS = 'manage-dealers',
    ADD_SUB_DEALER = 'add-sub-dealer',
    PAYMENT = 'payment',
    TRANSACTIONS = 'transactions',
    THANKYOU = 'thankyou',
    PROFILE = 'profile',
    LOGOUT = 'logout',
    CUSTOMER_DETAIALS = 'customer-details',
    VEHICLE_DETAILS = 'vehicle-details',
    REVIEW_DETAILS = 'review-details',
}

export enum SegmentEventNameTypes {
    VIEW = 'view',
    ACTION = 'action',
    EXCEPTION = 'exception',
}

export enum SegmentEventPages {
    VIEW_VEHICLE_DETAILS_PAGE = 'view_vehicle_details_page',
    COMMISSION_EARNED_V1_PAGE = 'commission_earned_v1_page',
    GENERATE_REPORT_INFO_POPUP = 'generate_report_info_popup',
    VIEW_PAGE = 'view_page',
    VIEW_LOGIN_PAGE = 'view_login_page',
    VIEW_LOGIN_OTP = 'view_login_otp',
    VIEW_HOMEPAGE_DEALER = 'view_homepage_dealer',
    VIEW_HAMBURGER_SCREEN = 'view_hamburger_screen',
    VIEW_MY_TRANSACTIONS = 'view_my_transactions',
    VIEW_COMMISSIONS_EARNED_V1_PAGE = 'view_commissions_earned_v1_page',
    VIEW_ADD_REMOVE_SUB_DEALER = 'view_add_remove_sub_dealer',
    VIEW_CONFIRM_SUB_DEALER = 'view_confirm_sub_dealer',
    VIEW_DEVICE_MODEL = 'view_device_model',
    VIEW_PLAN = 'view_plan',
    VIEW_PAYMENT_PAGE = 'view_payment_page',
    VIEW_MAIN_PAGE = 'view_main_page',
    VIEW_TRANSACTION_DETAIL_MODAL = 'view_transaction_detail_modal',
    VIEW_VEHICLE_VALIDATION_PAGE = 'view_vehicle_validation_page',
    VIEW_CUSTOMER_DETAILS_PAGE = 'view_customer_details_page',
    VIEW_REVIEW_DETAILS_PAGE = 'view_review_details_page',
    VIEW_SEND_LINK_TO_CUSTOMER_PAGE = 'view_send_link_to_customer_page',
    VIEW_CONGRATULATIONS_PAGE = 'view_congratulations_page',
}

export enum SegmentEventActions {
    TAP_DATE_TO_DATE_RANGE = 'tap_date_to_date_range',
    TAP_DATE_FROM_DATE_RANGE = 'tap_date_from_date_range',
    TAP_GROUPBY = 'tap_groupby',
    TAP_SUB_DEALER_SEARCH = 'tap_sub_dealer_search',
    TAP_SUB_DEALER_NAME = 'tap_sub_dealer_name',
    TAP_REPORT_HISTORY_TAB = 'tap_report_history_tab',
    TAP_REPORTS_TAB = 'tap_reports_tab',
    TAP_GENERATE_BTN = 'tap_generate_btn',
    TAP_REFRESH_BTN = 'tap_refresh_btn',
    TAP_DOWNLOAD_BTN = 'tap_download_btn',
    TAP_GENERATE_REPORT_INFO_BTN_OK = 'tap_generate_report_info_btn_ok',
}

export enum SegmentEventActionTypes {
    TAP_BTN = 'tap_btn',
    TAP_CALENDER = 'tap_calender',
    TAP_DROPDOWN = 'tap_dropdown',
    TAP_CHECKBOX = 'tap_checkbox',
    TAP_SEARCH = 'tap_search',
    ENTER_TEXT = 'enter_text',
}

export const PRODUCT = {
    ELECTRONICS: 'electronics',
    AUTO: 'auto',
};

export const SUB_PRODUCT_NAME = 'pos';

export enum SegmentEventButtonNames {
    LOGIN = 'login',
    MENU = 'menu',
    CREATE_NEW_PLAN = 'create_new_plan',
    MY_TRANSACTION = 'my_transaction',
    ADD_REMOVE_SUB_DEALER = 'add_remove_sub_dealer',
    CONFIRM_SUB_DEALER = 'confirm_sub_dealer',
    SELECT_MODEL = 'select_model',
    SELECT_PLAN = 'select_plan',
    CLICK_SERIAL_NUMBER = 'click_serial_number',
    CLICK_VIN_NUMBER = 'click_vin_number',
    SELECT_TRANSACTIONS_TYPE = 'select_transactions_type',
    CONTINUE_FROM_CUSTOMER_DETAILS = 'continue_from_customer_details',
    CONTINUE_FROM_VEHICLE_DETAILS = 'continue_from_vehicle_details',
    CLICK_EDIT_MODEL = 'click_edit_model',
    SEND_TO_CUSTOMER = 'send_to_customer',
    GO_HOME_BUTTON = 'go_home_button',
}

export enum SegmentEventActionNames {
    LOGIN_ATTEMPT = 'login_attempt',
    CLICK_MENU = 'click_menu',
    CREATE_NEW_PLAN = 'create_new_plan',
    CLICK_MY_TRANSACTIONS = 'click_my_transactions',
    CLICK_ADD_REMOVE_SUB_DEALERS = 'click_add_remove_sub_dealers',
    CLICK_CONFIRM_SUB_DEALERS = 'click_confirm_sub_dealers',
    SELECT_MODEL = 'select_model',
    SELECT_PLAN = 'select_plan',
    CLICK_SERIAL_NUMBER = 'click_serial_number',
    CLICK_VIN_NUMBER = 'click_vin_number',
    CLICK_TRANSACTION_ITEM = 'click_transaction_item',
    CLOSE_TRANSACTION_DETAILS_MODAL = 'close_transaction_details_modal',
    CLICK_RESEND_LINK_BUTTON = 'click_resend_link_button',
    ENTER_VIN_NUMBER = 'enter_vin_number',
    CLICK_VALIDATE_VIN_NUMBER_BUTTON = 'click_validate_vin_number_button',
    CLICK_BIN_NUMBER = 'click_bin_number',
    CLICK_CONTINUE_VEHICLE_DETAILS = 'click_continue_vehicle_details',
    CLICK_CONTINUE_CUSTOMER_DETAILS = 'click_continue_customer_details',
    ENTER_NAME = 'enter_name',
    ENTER_VALUE = 'enter_value',
    ENTER_MOBILE_NUMBER = 'enter_mobile_number',
    ENTER_EMAIL = 'enter_email',
    ENTER_ADDRESS = 'enter_address',
    ENTER_PINCODE = 'enter_pincode',
    CLICK_BACK_BUTTON = 'click_back_button',
    CLICK_EDIT_MODEL = 'click_edit_model',
    ISSUE_POLICY = 'issue_policy',
    SEND_LINK_TO_CUSTOMER = 'send_link_to_customer',
    CLICK_GO_HOME_BUTTON = 'click_go_home_button',
}

export enum SegmentEventFieldTypes {
    DROPDOWN = 'dropdown',
    TEXT = 'text',
    RADIO = 'radio',
    CHECKBOX = 'checkbox',
    DATE = 'date',
}

export enum SegmentEventPageTypes {
    MAIN_PAGE = 'main_page',
    VEHICLE_VALIDATION_PAGE = 'vehicle_validation_page',
    POPUP = 'popup',
    OVERLAY = 'overlay',
    NEW_PAGE = 'new_page',
    REDIRECT = 'redirect',
    DOWNLOAD = 'download',
    NAVIGATION = 'navigation',
    OTHER = 'other',
    VEHICLE_DETAILS_PAGE = 'vehicle_details_page',
    CUSTOMER_DETAILS_PAGE = 'customer_details_page',
    REVIEW_DETAILS_PAGE = 'review_details_page',
    SEND_LINK_TO_CUSTOMER_PAGE = 'send_link_to_customer_page',
    CONGRATULATIONS_PAGE = 'congratulations_page',
}
